import { wrapper, createApiClient, Result, ApiError } from "../base";
import ModuleDTO = App.Data.Auth.ModuleDTO;
import RedirectUrlDTO = App.Data.Auth.RedirectUrlDTO;

const baseClient = createApiClient();

export default class {
	resolveAuthentication(email?: string): Promise<Result<ModuleDTO, ApiError>> {
		return wrapper(baseClient.post(`auth/resolve`, { email }));
	}
	getMicrosoftEntraIDRedirectUrl(
		moduleUuid: string
	): Promise<Result<RedirectUrlDTO, ApiError>> {
		return wrapper(baseClient.get(`auth/microsoft/redirect-url/${moduleUuid}`));
	}
}
